// Multi-territory Compliance Master column + search-field configuration.
// Mirrors the India config (src/constants/complianceMasterColumn.jsx).

import { formatCompliancePeriod } from '@/utils/complianceMasterUtils'
import { z } from 'zod'

export interface MTComplianceColumn {
  id: string
  label: string
  width?: string
  type?: string
  render?: (value: unknown, row?: Record<string, any>) => unknown
}

export const MT_COMPLIANCE_MASTER_COLUMNS: MTComplianceColumn[] = [
  {
    id: 'countryName',
    label: 'Country',
    width: '150px',
  },
  {
    id: 'entityName',
    label: 'Entity name',
  },
  {
    id: 'tanName',
    label: 'Entity TAN',
    width: '150px',
  },
  {
    id: 'complianceCategory',
    label: 'Compliance category',
  },
  {
    id: 'compliancePeriod',
    label: 'Compliance period',
    width: '165px',
    render: (value, row) =>
      formatCompliancePeriod(
        value as string,
        row?.complianceStartDate,
        row?.complianceFrequency ? [row.complianceFrequency] : []
      ),
  },
  {
    id: 'complianceDueDate',
    label: 'Due date',
    width: '120px',
  },
  {
    id: 'createdBy',
    label: 'Created by',
    width: '170px',
  },
  {
    id: 'createdDate',
    label: 'Created date',
    width: '170px',
    type: 'date',
  },
]

// Validation for dd/mm/yyyy date list format
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )

export const MT_COMPLIANCE_MASTER_SEARCH_FIELDS =
  MT_COMPLIANCE_MASTER_COLUMNS.filter(col => col.id !== 'name').map(col => {
    if (
      col.id === 'complianceDueDate' ||
      col.id === 'complianceCompletionDate' ||
      col.id === 'createdDate'
    ) {
      return {
        ...col,
        type: 'text',
        placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
        zod: ddMMyyyyListZod,
      }
    }
    return {
      id: col.id,
      label: col.label,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    }
  })
